<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="row clearfix breadcrumb-margin-lg">
        <div class="col-md-6 col-sm-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item"><a href="#">Skill</a></li>
              <li class="breadcrumb-item active" aria-current="page">Add Skill</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-6 col-sm-12 text-right">
          <router-link
            :to="'/admin/master/skill'"
            class="btn btn-outline-danger"
            title="Go to Skills"
            ><i class="fa fa-arrow-circle-left mr-2"></i>Back</router-link
          >
        </div>
      </div>
    </div>

    <div class="row clearfix">
      <div class="col-md-8 mx-auto">
        <div class="card">
          <div class="card-header bg-primary custom-title theme-backcolor">
            <h6 class="text-white fs">Add New Skill</h6>
          </div>
          <v-app class="fixVapp">
            <div class="body">
              <v-container>
                <form>
                  <v-row dense>
                    <v-col cols="12">
                      <label class="text-muted">Select Category</label>
                      <v-autocomplete
                        attach
                        label=""
                        v-model="selected"
                        :items="categories"
                        item-text="category_title"
                        item-value="category_id"
                        outlined
                        class="mt-n8"
                        :error-messages="errors.category_id"
                        dense
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="mt-n4">
                      <label class="text-muted">Skill Title</label>
                      <v-text-field
                        type="text"
                        name="skill_title"
                        v-model="skill_title"
                        label=""
                        class="mt-n8"
                        outlined
                        dense
                        autocomplete="off"
                        :error-messages="errors.skill_title"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" class="mt-n4">
                      <label class="text-muted">Description</label>
                      <v-text-field
                        type="text"
                        name="skill_description"
                        v-model="skill_description"
                        label=""
                        required
                        outlined
                        dense
                        class="mt-n8"
                        aucomplete="off"
                        :error-messages="errors.skill_description"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <div class="mx-auto d-flex justify-content-center mt-0">
                      <button
                        type="button"
                        class="btn btn-primary text-white theme-backcolor"
                        @click="AddSkill"
                      >
                        <i class="fa fa-save mr-2"></i>Save
                      </button>
                      <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                      </v-overlay>
                    </div>
                  </v-row>
                </form>
              </v-container>
            </div>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataService from '../../../dataservice';
import Formerror from '../../pages/formerror';
export default {
  components: {
    'form-error': Formerror,
  },
  data() {
    return {
      errors: '',
      categories: [],
      selected: null,
      skill_title: '',
      skill_description: '',
      overlay: false,
    };
  },
  created() {
    DataService.getAllCategory()
      .then(response => {
        this.categories = response.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
    },
  },
  methods: {
    AddSkill() {
      this.overlay = true;
      const data = new FormData();
      data.append('skill_title', this.skill_title);
      data.append('skill_description', this.skill_description);
      data.append('category_id', this.selected);
      DataService.createSkill(data)
        .then(response => {
          this.errors = '';
          this.skill_title = '';
          this.skill_description = '';
          this.s('Skill', 'Record Added Successfully!');
        })
        .catch(error => {
          this.errors = error.response.data.error;
          this.overlay = false;
          this.e("Oop's", 'Something went wrong.');
        });
    },
  },
};
</script>
<style scoped>
.fixVapp {
  height: 100px;
}
.custom-title {
  padding: 8px 20px !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.fs {
  font-size: 18px !important;
  font-weight: 600 !important;
}
</style>
